var React = require('react');

function ArrowTopInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.00154 0.791827C7.267 0.791827 7.50833 0.888345 7.70139 1.08141L13.7345 7.35588C13.9035 7.54894 14 7.79028 14 8.03161C14 8.29706 13.9035 8.5384 13.7104 8.73146C13.3243 9.09345 12.721 9.09345 12.3348 8.70733L7.00154 3.15683L1.66824 8.70733C1.30625 9.09345 0.678805 9.09345 0.292684 8.73146C-0.0934379 8.36947 -0.0934394 7.742 0.26855 7.35588L6.3017 1.08141C6.49476 0.888345 6.73609 0.791827 7.00154 0.791827Z","fill":"white"}));
}

ArrowTopInline.defaultProps = {"width":"14","height":"9","viewBox":"0 0 14 9","fill":"none"};

module.exports = ArrowTopInline;

ArrowTopInline.default = ArrowTopInline;
